import { render, staticRenderFns } from "./shareList.vue?vue&type=template&id=2ee07994&"
import script from "./shareList.vue?vue&type=script&lang=js&"
export * from "./shareList.vue?vue&type=script&lang=js&"
import style0 from "./shareList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports